import React from "react";
import { Breadcrumbs, Link } from "@mui/material";
import { CgChevronDoubleRight } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import { IconType } from "react-icons";

export type BreadcrumbType = {
  label: string;
  onClick?: () => void;
  path?: string;
  icon?: IconType;
  extraClass?:string
};

type Props = {
  breadcrumbs: BreadcrumbType[];
};

const ATMBreadCrumbs = ({ breadcrumbs }: Props) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs
      separator={
        <CgChevronDoubleRight className="text-xl text-blue-600" />
      }
      aria-label="breadcrumb"
      
    >
      {breadcrumbs?.map((breadcrumb, breadcrumbIndex) => (
        <Link
          underline={breadcrumb.path ? "hover" : "none"}
          key={breadcrumbIndex}
          color="inherit"
          onClick={() => {
            breadcrumb.onClick && breadcrumb.onClick();
            breadcrumb.path && navigate(breadcrumb.path);
          }}
          className={`${breadcrumb.path && "cursor-pointer"}`}
        >
          <span
            className={`text-sm flex gap-1 items-center  ${
              breadcrumb.path ? "text-gray-600" : "text-blue-600"
            }  ${breadcrumb.extraClass}`}
          >
            {/* {breadcrumb.icon && <breadcrumb.icon className="text-[18px]" />} */}
            {breadcrumb.label}
          </span>
        </Link>
      ))}
    </Breadcrumbs>
  );
};

export default ATMBreadCrumbs;
